export default __webpack_public_path__ + "static/media/GDYY5nKHVPk-1718909341680.7e395f41.jpg";